export default {
  LIST_CUSTOMER_GIFTS_REDEEMED: 'customer-gifts/redeemed/list',
  LIST_CUSTOMER_GIFTS_REDEEMED_NEXT: 'customer-gifts/redeemed/list/next',
}
